import styled from "styled-components";

export const CardAtis = styled.div`
  position: relative;
  min-width: 140px;
  min-height: 140px;
  box-shadow: inset 5px 5px 5px rgba(0, 0, 0, 0.2),
    inset -5px -5px 15px rgba(255, 255, 255, 0.1),
    5px 5px 15px rgba(0, 0, 0, 0.3), -5px -5px 15px rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  margin: 10px;
  padding: 15px;
  transition: 0.5s;
`;

export const Box = styled.div`
  /* position: absolute; */
  /* top: -15px;
  left: -15px;
  right: -15px;
  bottom: -15px; */
  min-width: inherit;
  min-height: inherit;

  background: #032156;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transition: 0.5s;

  :hover {
    transform: translateY(-30px);
  }

  /* :before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    background: rgba(255, 255, 255, 0.04);
  } */
`;

export const Content = styled.div`
  padding: 5px;
  text-align: center;

  h3 {
    font-size: 1rem;
    color: #fff;
    z-index: 1;
    transition: 0.5s;
    margin-bottom: 5px;
  }

  p {
    font-size: 0.8rem;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.9);
    z-index: 1;
    transition: 0.5s;
    word-break: break-word;
    max-width: 120px;
    margin-left: auto;
    margin-right: auto;
  }

  a {
    margin-right: 5px;
  }
`;

export const FormCard = styled.section`
  margin-top: 30px;
  label {
    color: #fff;
    font-size: 0.8rem;
    margin-right: 10px !important;
  }
  form input {
    max-width: 180px !important;
  }
  button {
    margin-top: 10px;
  }
`;
